import * as React from "react"

const SvgPhoneMobile = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={76}
    height={76}
    viewBox="0 0 76 76"
    {...props}
  >
    <g transform="translate(-340 -62)">
      <circle
        data-name="Ellipse 40"
        cx={38}
        cy={38}
        r={38}
        transform="translate(340 62)"
        fill="#ce1213"
      />
      <g
        data-name="Ellipse 41"
        transform="translate(346 68)"
        fill="none"
        stroke="#fff"
        strokeWidth={2}
      >
        <circle cx={32} cy={32} r={32} stroke="none" />
        <circle cx={32} cy={32} r={31} />
      </g>
      <g data-name="Layer 2">
        <g data-name="Layer 1" fill="#fff">
          <path
            data-name="Path 3"
            d="M387.044 116.997a16.111 16.111 0 0 1-3.963-.884 31.761 31.761 0 0 1-9.749-5.725 39.818 39.818 0 0 1-9.961-12 22.177 22.177 0 0 1-2.311-6.457 2.524 2.524 0 0 1 .389-2.034 37.219 37.219 0 0 1 5.216-6.143 5.481 5.481 0 0 1 .688-.534.864.864 0 0 1 1.234.083 3.348 3.348 0 0 1 .542.581 46.2 46.2 0 0 1 4.137 6.872c.621 1.315.559 1.535-.53 2.5q-1.065.953-2.154 1.907a.492.492 0 0 0-.149.6 17.28 17.28 0 0 0 5.58 8.4 16.436 16.436 0 0 0 6.218 3.359.448.448 0 0 0 .529-.139c.607-.694 1.229-1.375 1.835-2.07 1.051-1.208 1.282-1.278 2.711-.586a45.253 45.253 0 0 1 6.677 4.029c1.214.872 1.259 1.379.255 2.473a33.335 33.335 0 0 1-6.491 5.439 4.9 4.9 0 0 1-.705.334Z"
          />
          <path
            data-name="Path 4"
            d="M379.177 85.415v-2.358c7.857-.327 15.831 6.556 15.744 15.7h-2.388a13.431 13.431 0 0 0-13.356-13.342Z"
          />
          <path
            data-name="Path 5"
            d="M388.845 98.774h-2.327c-.467-4.414-2.889-6.855-7.328-7.343v-2.324a9.622 9.622 0 0 1 9.655 9.667Z"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default SvgPhoneMobile
